import * as querystring from 'querystring';
const IMAGE_SIZES = [
    36,
    72,
    144,
    180,
    256,
    360,
    480,
    512,
    640,
    720,
    850,
    960,
    1024,
    1280,
    1360,
    1440,
    1536,
    1700,
    1920,
    2048,
    2560,
];
/**
 * Returns nearest image resize width for the given width.
 * @param {number} width The given width.
 * @return {number} The image width.
 */
export function getNearestWidth(width) {
    for (let i = 0; i < IMAGE_SIZES.length; ++i) {
        if (IMAGE_SIZES[i] >= width) {
            return IMAGE_SIZES[i];
        }
    }
    return IMAGE_SIZES[IMAGE_SIZES.length - 1];
}
const IMAGE_OHOUSE_LEGACY_PATTERN = /^https?:\/\/image\.ohou\.se\/image\/(?:central_crop|resize)\/([^/]+)\/([^/]+)\/.+\/.*$/;
const IMAGE_OHOUSE_PATTERN = /^https?:\/\/image\.ohou\.se\/i\/([^/]+)\/([^?]+)(?:\?.*)?$/;
const S3_LOCAL_PATTERN = /^https?:\/\/s3-ap-northeast-1\.amazonaws\.com\/([^/]+)\/([^?]+)(?:\?.*)?$/;
const S3_GLOBAL_PATTERN = /^https?:\/\/([^.]+)\.(?:s3\.amazonaws\.com|cloudfront\.net)\/([^?]+)(?:\?.*)?$/;
const IMAGE_PREFIX = 'https://image.ohou.se';
/**
 * Returns the resized image URL for the given image. It can convert server-
 * converted image URL, or raw S3 image URL.
 * @param {string} src The original image URL.
 * @param {number} width The image width to use.
 * @param {number} aspect The aspect ratio for height - provide null to retain
 *   original width.
 * @param {number} quality The quality of the image.
 * @return {string} The resized image URL.
 */
export default function getImageUrl(src, width, height, mode, quality, webp, gif) {
    let path;
    let match;
    const alignWidth = width != null ? getNearestWidth(width) : null;
    const alignHeight = height != null ? getNearestWidth(height) : height;
    if (!src) {
        return undefined;
    }
    if (match = IMAGE_OHOUSE_LEGACY_PATTERN.exec(src), match != null) {
        path = `${match[1]}/${match[2].replace(/-/g, '/')}`;
    }
    else if (match = IMAGE_OHOUSE_PATTERN.exec(src), match != null) {
        path = `${match[1]}/${match[2]}`;
    }
    else if (match = S3_LOCAL_PATTERN.exec(src), match != null) {
        path = `${match[1]}/${match[2]}`;
    }
    else if (match = S3_GLOBAL_PATTERN.exec(src), match != null) {
        // eslint-disable-next-line prefer-destructuring
        let bucketName = match[1];
        // Change old bucket name to new name
        if (bucketName === 'd224jl0o7z9gbn' || bucketName === 'd12gkpu9h0k5iq') {
            bucketName = 'bucketplace-v2-development';
        }
        path = `${bucketName}/${match[2]}`;
    }
    else {
        return src;
    }
    const url = `${IMAGE_PREFIX}/i/${path}?`;
    const query = {};
    if (alignWidth != null)
        query.w = String(alignWidth);
    if (alignHeight != null)
        query.h = String(alignHeight);
    if (mode != null)
        query.c = String(mode);
    if (quality != null)
        query.q = String(quality);
    if (webp)
        query.webp = '1';
    if (gif)
        query.gif = '1';
    return url + querystring.stringify(query);
}
export function getImageUrlSingleAxis(src, width, aspect, quality, useHeight, webp, gif) {
    if (aspect != null) {
        if (useHeight) {
            return getImageUrl(src, width * aspect, width, 'c', quality, webp, gif);
        }
        return getImageUrl(src, width, width * aspect, 'c', quality, webp, gif);
    }
    if (useHeight) {
        return getImageUrl(src, undefined, width, undefined, quality, webp, gif);
    }
    return getImageUrl(src, width, undefined, undefined, quality, webp, gif);
}
//# sourceMappingURL=getImageUrl.js.map